import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { useQuery } from 'react-query'
import { getBankData } from 'services/api/modules/staff-management/staffManagementDashboard'
import { salaryCategories, banks } from 'services/api/dropdown'

import SalaryDetails from '../components/SalaryDetails'
import StatutoryBodyDetails from '../components/StatutoryBodyDetails'
import { getCompanyDetails } from 'services/api/company-details'
import Bugsnag from '@bugsnag/js'

const BankTab = ({ windowCheckEmployeeFile, employeeID }) => {
  const { data: bank } = useQuery(
    ['employeeBankData', employeeID],
    async () => {
      window.scrollTo(0, 0)
      const { data } = await getBankData(employeeID)
      return data
    },
    {
      onError: (error) => {
        Bugsnag.notify(error)
      },
    }
  )
  const { data: salCat } = useQuery(
    'salaryCategories',
    async () => {
      const { data } = await salaryCategories()
      return data
    },
    {
      onError: (error) => {
        Bugsnag.notify(error)
      },
    }
  )
  const { data: bankDropdown } = useQuery(
    'bankCategories',
    async () => {
      const { data } = await banks()
      return data
    },
    {
      onError: (error) => {
        Bugsnag.notify(error)
      },
    }
  )

  //to retrieve company's hrdf status
  const { data: companyDetails, refetch: refetchCompanyDetails } = useQuery(
    'companyDetails',
    async () => {
      const { data } = await getCompanyDetails()
      return data
    },
    {
      onError: (error) => {
        if (error.status !== 403) {
          Bugsnag.notify(error)
        }
      },
    }
  )
  useEffect(() => {
    refetchCompanyDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <SalaryDetails
          data={bank}
          employeeID={employeeID}
          salCat={salCat}
          bankDropdown={bankDropdown}
          windowCheckEmployeeFile={windowCheckEmployeeFile}
        />
      </Box>
      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <StatutoryBodyDetails
          data={bank}
          employeeID={employeeID}
          windowCheckEmployeeFile={windowCheckEmployeeFile}
          company_hrdf_status={companyDetails?.hrdf_status}
          company_skbbk_enabled={companyDetails?.skbbk_enabled}
          company_skbbk_deduct_from_salary={companyDetails?.skbbk_deduct_from_salary}
        />
      </Box>
    </Box>
  )
}

export default BankTab
